<template>
  <div class="doc">
    <yu-head/>
    <div class="container">
      <yu-menu/>
      <yu-article>
        <div class="phone">
          <iframe src="http://mobileweb.yurencloud.com/#/refresh" frameborder="0" width="320" height="580"></iframe>
        </div>


        <div class="title">下拉刷新</div>
        <yu-alert title="注意"
                  type="error"
                  description='下拉刷新使用了touch事件，在PC端无效，请用手机扫顶部二维码测试。'
                  />
        <yu-message></yu-message>
        <div class="sub-title">普通用法</div>
        <pre v-highlightjs="code1"><code class="html" ></code></pre>
        <pre v-highlightjs="code2"><code class="javascript" ></code></pre>

        <div class="sub-title">属性</div>
        <yu-table :data="attributes1" :widths="widths1"/>

      </yu-article>
    </div>
  </div>
</template>

<script>
import { YuTable, YuAlert } from 'yu.ui';
import { YuButton, YuText } from 'yu.mobile';
import YuHead from './yu-head';
import YuMenu from './yu-menu';
import YuArticle from './yu-article';

export default {
  name: 'Buttons',
  data() {
    return {
      code1: `
  <yu-nav-bar title="今日头条新闻" />
  <yu-refresh :on-refresh="onRefresh"
              :on-infinite="onInfinite"
              :dataList="scrollData">
    <yu-lists>
      <yu-list :title="item.date"
                v-bind:key="index"
                v-for="(item,index) in listdata" />
    </yu-lists>
  </yu-refresh>
      `,
      code2: `
  import { YuRefresh, YuNavBar, YuLists, YuList } from 'yu.mobile';

  export default {
    name: 'HelloWorld',
    data() {
      return {
        counter: 1, // 当前页
        num: 10, // 一页显示多少条
        pageStart: 0, // 开始页数
        pageEnd: 0, // 结束页数
        listdata: [], // 下拉更新数据存放数组
        scrollData: {
          noFlag: false, // 暂无更多数据显示
        },
      };
    },
    mounted() {
      this.getList();
    },
    methods: {
      getList() {
        const response = [];
        for (let i = 0; i < 20; i++) {
          response.push({
            date: \`2017-06-1\${i}\`,
          });
        }
        this.listdata = response.slice(0, this.num);
      },
      onRefresh(done) {
        this.getList();
        this.scrollData.noFlag = false;
        this.counter = 1;
        this.pageStart = 0; // 开始页数
        this.pageEnd = 0; // 结束页数
        done(); // call done
      },
      onInfinite(done) {
        this.counter++;
        const end = this.pageEnd = this.num * this.counter;
        let i = this.pageStart = this.pageEnd - this.num;

        const more = this.$el.querySelector('.load-more');
        for (i; i < end; i++) {
          if (i >= 30) {
            more.style.display = 'none'; // 隐藏加载条
            // 走完数据调用方法
            this.scrollData.noFlag = true;
            break;
          } else {
            this.listdata.push({
              date: \`2017-06-1\${i}\`,
            });
            more.style.display = 'none'; // 隐藏加载条
          }
        }
        done();
      },
    },
    components: {
      YuRefresh,
      YuList,
      YuLists,
      YuNavBar,
    },
  };
      `,
      attributes1: [
        {
          prop: '参数',
          description: '说明',
          types: '类型',
          default: '默认值',
        },
        {
          prop: 'offset',
          description: '下拉触发刷新的高度差(px)',
          types: 'Number',
          default: '100',
        },
        {
          prop: 'enableInfinite',
          description: '是否可以上拉加载数据',
          types: 'Boolean',
          default: 'true',
        },
        {
          prop: 'enableRefresh',
          description: '是否允许刷新',
          types: 'Boolean',
          default: 'true',
        },
        {
          prop: 'dataList',
          description: '数据列表',
          types: 'Array',
          default: '无',
        },
        {
          prop: 'onRefresh',
          description: '刷新时要触发的函数',
          types: 'Function',
          default: 'undefined',
        },
        {
          prop: 'onInfinite',
          description: '加载数据时要触发的函数',
          types: 'Function',
          default: 'undefined',
        },
      ],

      widths1: {
        prop: '150px',
        description: '300px',
        types: '120px',
        default: '200px',
      },
    };
  },
  components: {
    YuHead,
    YuMenu,
    YuArticle,
    YuTable,
    YuButton,
    YuText,
    YuAlert,
  },
};
</script>

<style lang="scss" scoped type="text/scss">
  @import "../assets/css/varible";

  .doc {
    color: $text;
    height: 100%;
    .container {
      width: 1200px;
      margin: 30px auto;
      .title {
        color: $text;
        font-weight: bold;
        padding: 14px 0;
        margin: 20px 0;
        border-bottom: 1px solid $border;
      }
      .sub-title {
        color: $text;
        padding: 0 8px;
        margin: 20px 0;
        border-left: 4px solid $primary;
      }
    }

    .phone{
      text-align: center;
      iframe {
        margin: 20px auto;
        border-radius: 20px;
        &::-webkit-scrollbar {
          width: 0;
        }
        border: 10px solid $border;

      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/refresh.vue